import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'rb-check-point',
  imports: [RouterOutlet],
  templateUrl: './check-point.component.html',
  styleUrl: './check-point.component.scss',
})
export class CheckPointComponent {}
